import {
  adaptRequestMultiItemFieldsToDict,
  adaptRequestSortAndFiltersToDict,
  adaptRequestToDict,
} from 'stores/adapters/bex-api/search/request-fields-adapter';

import { DefaultRequestFields } from 'models';

import { LodgingPwaPropertySearch, OperationResult } from '__generated__/api';

export const getDefaultRequestFields = (
  criteria: LodgingPwaPropertySearch.Criteria,
  multiItemId: string,
  bexApiResults: OperationResult<LodgingPwaPropertySearch.Query>
): DefaultRequestFields | null => ({
  ...adaptRequestToDict(criteria),
  ...adaptRequestSortAndFiltersToDict(criteria),
  ...adaptRequestMultiItemFieldsToDict(multiItemId, bexApiResults),
});
